/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import SessionCollection from './sessioncollection';
import { IWebSocketGateway } from '../websocketgateway/websocketgateway';

/**
 * Abstracts requesting connected Sessions for services. Should not be used directly
 */
export default class Sessions {
	/**
	 * Returns a Promise that resolves with read-only observable collection with EndUsers Sessions for given service instance.
	 *
	 *    const sessions = await wsGateway.getConnectedSessions( wsGateway, 'some-uuid', 'session-type' );
	 */
	public static async getConnectedSessions( wsGateway: IWebSocketGateway, id: string, sessionType: number ): Promise<SessionCollection> {
		const sessionCollection: SessionCollection = new SessionCollection( id, sessionType );

		await sessionCollection.connect( wsGateway );

		return sessionCollection;
	}
}
